import { render } from "./WnTablePages.vue?vue&type=template&id=559a9099&scoped=true"
import script from "./WnTablePages.vue?vue&type=script&lang=js"
export * from "./WnTablePages.vue?vue&type=script&lang=js"

import "./WnTablePages.vue?vue&type=style&index=0&id=559a9099&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-559a9099"]])

export default __exports__